// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";

function useScript(src, typeOpt, integrityOpt, crossoriginOpt) {
  let type = typeOpt !== undefined ? typeOpt : "";
  let integrity = integrityOpt !== undefined ? integrityOpt : "";
  let crossorigin = crossoriginOpt !== undefined ? crossoriginOpt : "";
  let match = React.useState(() => {
    if (src !== "") {
      return "loading";
    } else {
      return "idle";
    }
  });
  let setStatus = match[1];
  React.useEffect(() => {
    if (src === "") {
      setStatus(param => "idle");
    }
    let script = document.querySelector(`script[src="` + src + `"]`);
    if (script == null) {
      let script$1 = document.createElement("script");
      script$1.src = src;
      if (type !== "") {
        script$1.type = type;
      }
      if (crossorigin !== "") {
        script$1.setAttribute("crossorigin", crossorigin);
      }
      if (integrity !== "") {
        script$1.setAttribute("integrity", integrity);
      }
      script$1.async = true;
      script$1.setAttribute("data-status", "loading");
      document.body.appendChild(script$1);
      let setAttributeFromEvent = event => {
        setStatus(param => {
          if (event.type === "load") {
            return "ready";
          } else {
            return "error";
          }
        });
        script$1.setAttribute("data-status", event.type === "load" ? "ready" : "error");
      };
      script$1.addEventListener("load", setAttributeFromEvent);
      script$1.addEventListener("error", setAttributeFromEvent);
      return () => {
        script$1.removeEventListener("load", setAttributeFromEvent);
        script$1.removeEventListener("error", setAttributeFromEvent);
        if (script$1.getAttribute("data-status") !== "ready") {
          return script$1.remove();
        }
      };
    }
    setStatus(param => script.getAttribute("data-status"));
  }, [src]);
  return match[0];
}

function useLink(src) {
  let match = React.useState(() => {
    if (src !== "") {
      return "loading";
    } else {
      return "idle";
    }
  });
  let setStatus = match[1];
  React.useEffect(() => {
    if (src === "") {
      setStatus(param => "idle");
    }
    let link = document.querySelector(`link[href="` + src + `"]`);
    if (link == null) {
      let link$1 = document.createElement("link");
      link$1.href = src;
      link$1.rel = "stylesheet";
      link$1.setAttribute("data-status", "loading");
      document.body.appendChild(link$1);
      let setAttributeFromEvent = event => {
        setStatus(param => {
          if (event.type === "load") {
            return "ready";
          } else {
            return "error";
          }
        });
        link$1.setAttribute("data-status", event.type === "load" ? "ready" : "error");
      };
      link$1.addEventListener("load", setAttributeFromEvent);
      link$1.addEventListener("error", setAttributeFromEvent);
      return () => {
        link$1.removeEventListener("load", setAttributeFromEvent);
        link$1.removeEventListener("error", setAttributeFromEvent);
      };
    }
    setStatus(param => link.getAttribute("data-status"));
  }, [src]);
  return match[0];
}

function updateKeys(dict, keyPair, setKeys) {
  let value = keyPair[1];
  let key = keyPair[0];
  let valueStr = Utils$OrcaPaymentPage.getStringFromJson(value, "");
  let valueBool = $$default => Core__Option.getOr(Core__JSON.Decode.bool(value), $$default);
  if (!Utils$OrcaPaymentPage.getDictIsSome(dict, key)) {
    return;
  }
  switch (key) {
    case "iframeId" :
      return setKeys(prev => {
        let newrecord = {...prev};
        newrecord.iframeId = Utils$OrcaPaymentPage.getString(dict, key, valueStr);
        return newrecord;
      });
    case "parentURL" :
      return setKeys(prev => {
        let newrecord = {...prev};
        newrecord.parentURL = Utils$OrcaPaymentPage.getString(dict, key, valueStr);
        return newrecord;
      });
    case "paymentId" :
      return setKeys(prev => {
        let newrecord = {...prev};
        newrecord.paymentId = Utils$OrcaPaymentPage.getString(dict, key, valueStr);
        return newrecord;
      });
    case "publishableKey" :
      return setKeys(prev => {
        let newrecord = {...prev};
        newrecord.publishableKey = Utils$OrcaPaymentPage.getString(dict, key, valueStr);
        return newrecord;
      });
    case "sdkHandleOneClickConfirmPayment" :
      return setKeys(prev => {
        let newrecord = {...prev};
        newrecord.sdkHandleOneClickConfirmPayment = Utils$OrcaPaymentPage.getBool(dict, key, valueBool(true));
        return newrecord;
      });
    default:
      return;
  }
}

function useDebounce(delayMs) {
  let timerRef = React.useRef(undefined);
  let cancelDebounce = React.useCallback(() => {
    Core__Option.forEach(timerRef.current, prim => {
      clearTimeout(prim);
    });
    timerRef.current = undefined;
  }, []);
  let startDebounce = React.useCallback(callback => {
    Core__Option.forEach(timerRef.current, prim => {
      clearTimeout(prim);
    });
    let timerId = setTimeout(() => {
      timerRef.current = undefined;
      callback();
    }, delayMs);
    timerRef.current = Primitive_option.some(timerId);
  }, [delayMs]);
  React.useEffect(() => (() => Core__Option.forEach(timerRef.current, prim => {
    clearTimeout(prim);
  })), []);
  return {
    startDebounce: startDebounce,
    cancelDebounce: cancelDebounce
  };
}

let defaultkeys = {
  clientSecret: undefined,
  sdkAuthorization: undefined,
  paymentId: "",
  publishableKey: "",
  iframeId: "",
  parentURL: "*",
  sdkHandleOneClickConfirmPayment: true
};

export {
  useScript,
  useLink,
  updateKeys,
  useDebounce,
  defaultkeys,
}
/* react Not a pure module */
